import React, { useEffect, useState, useContext } from 'react'
import { Row, Col, Card } from "react-bootstrap"
import { withTranslation } from 'react-i18next'
import Get from '../../api/Get'
import { DOCTOR_BY_EMAIL, DOCTOR_NOTIFICACIONES } from '../../api/Routes'
import { authContext } from "../../context/AuthContext";
import PerfilDoctorInfo from '../../components/doctor/PerfilDoctorInfo';
import PerfilTabs from '../../components/doctor/PerfilTabs'
import LoadingList from "../../loader/LoadingList";
import ComponentModalErrorSever from '../../components/ComponentModalErrorSever'

function DoctorPerfil({url}) {
    const [doctorInfo, setDoctorInfo] = useState(null)
    const [loading, setLoading] = useState(false)
    const [notificaciones, setNotificaciones] = useState([])
    const [idDoctor, setIdDoctor] = useState(null)
    const [showModalError, setShowModalError] = useState(false)
    const [errorServer, setErrorServer] = useState(null)
    const handleClose = () => setShowModalError(false)

    //Token de autentificación para los servicios
    const {auth} = useContext(authContext)

    //Get información del doctor
    useEffect(() => {
        let mounted = true
        const url = encodeURI(`${DOCTOR_BY_EMAIL}/${auth.data.username}`)
        setLoading(true)

        Get({url: url, access_token: auth.data.access_token})
        .then((resp) => {
            //console.log(resp)
            if(mounted){
                setDoctorInfo(resp.data.data)
                setIdDoctor(resp.data.data.id)
            }
            setLoading(false)
        })
        .catch((error) => {
            setShowModalError(true)
            if(error.response){
                setErrorServer(error.response)
            }
            setLoading(false)
        })
        return () => mounted = false;
    }, [])

    //Get notificaciones
    useEffect(() => {
        if(idDoctor){
            let mounted = true;
            const url = encodeURI(`${DOCTOR_NOTIFICACIONES}/${idDoctor}`)
            setLoading(true)

            Get({url: url, access_token: auth.data.access_token})
            .then((resp) => {
                if(mounted){
                    let data = resp.data.data.response;
                    setNotificaciones(data)
                }
                setLoading(false)
            })
            .catch((error) => {
                setShowModalError(true)
                if(error.response){
                    setErrorServer(error.response)
                }
                setLoading(false)
            })
            return () => mounted = false;
        }
    }, [idDoctor])

    return (<>
        {
            loading ? <LoadingList texto='' /> :
            <div className="body">
                <Row>
                    <Col xs="12" sm="12" md="5" lg="4" xl="4">
                        <PerfilDoctorInfo url={url} doctorInfo={doctorInfo} />
                    </Col>
                    <Col xs="12" sm="12" md="7" lg="8" xl="8">
                        <Card className="shadow-1 formSection doctor-informacion">
                            <PerfilTabs 
                                doctorInfo={doctorInfo}
                                notificaciones={notificaciones} 
                                auth={auth} 
                                setDoctorInfo={setDoctorInfo}
                            />
                        </Card>
                    </Col>
                </Row>
            </div>
        }
        <ComponentModalErrorSever 
            show={showModalError}
            handleClose={handleClose}
            error={errorServer}
        />
        
    </>)
}

export default withTranslation()(DoctorPerfil)